import { Injectable, InjectionToken } from '@angular/core';
import { LifeSpan } from './life-span';

export const CACHESETTINGS = new InjectionToken<CacheSettings>('CACHESETTINGS');

export interface CacheSettings {
  key: string;
  lifeSpan: LifeSpan;
}
